<div *ngIf="image !=''" [ngClass]="doCenter">
  <img (error)="onImgError($event)" [src]="cleanURL(image)" height="614" width="421">
</div>
<div *ngIf="imageOverSized !=''" class="center-card">
  <img (error)="onImgError($event)" [src]="cleanURL(imageOverSized)" class='oversize'>
</div>
<div *ngIf="pixel !=''" class="center-card">
  <img (error)="onImgError($event)" [src]="cleanURL(pixel)" class='oversize'>
</div>
